/**
 * Password reset from the global login. It lives here rather than linking to an
 * app's own `/auth/forgot`, because on this host those apps have no company yet
 * and send a signed-out visitor straight back to sign in.
 *
 * No company is sent: the backend finds it from the email and puts it in the
 * link it mails, so the link opens without this host having to know.
 */
import type { JSX } from "react";
import { useNavigate } from "@tanstack/react-router";
import { AuthLayout, ResetRequestForm, useAuthBranding } from "@linkhr/auth/pages";
import { env } from "./env";

export function ForgotPasswordPage(): JSX.Element {
  const navigate = useNavigate();
  const branding = useAuthBranding("", { passive: true });
  return (
    <AuthLayout branding={branding}>
      <ResetRequestForm
        tenantSlug=""
        apiBaseUrl={env.VITE_API_BASE_URL}
        onBack={() => {
          void navigate({ to: "/", search: true });
        }}
      />
    </AuthLayout>
  );
}
